import type { BaseController } from '@infra/controllers/base.controller';
import type { ApplyTagsUsecase, ApplyTagsRequest } from './apply-tags.usecase';

export type ApplyTagsInput = {
  callId: string;
  tagIds: number[];
};

export type ApplyTagsOutput = {
  success: boolean;
};

export class ApplyTagsController
  implements BaseController<ApplyTagsInput, ApplyTagsOutput>
{
  constructor(private usecase: ApplyTagsUsecase) {}

  async handle(input: ApplyTagsInput): Promise<ApplyTagsOutput> {
    const request: ApplyTagsRequest = {
      callId: input.callId,
      tagIds: input.tagIds,
    };

    return this.usecase.run(request);
  }
}
